export const generateSecretToken = (n: number): string => {
  return Array.from(crypto.getRandomValues(new Uint8Array(n)))
    .map(n => {
      const hex = (n % 256).toString(16)
      return hex.length === 2 ? hex : `0${hex}`
    })
    .join('')
}
